import Prompt from "./Prompt.svelte"
import { openBottomPopup } from "./bottomPopup.module"

export function createPrompt(props: {
    headline?: string
    detail?: string
    action: () => void
    buttonLabel?: string
    type?: string
    cancel?: () => void
    cancelButtonlabel?: string
    secondButtonLabel?: string
    secondButtonType?: string
    secondButtonAction? : () => void
}) {
    openBottomPopup(Prompt, props)
}
